import React from "react";

// Swiss flag as an inline SVG (red square with white cross)
export default function SwissFlag({ className = "swiss-flag" }) {
  return (
    <svg className={className} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="Swiss flag">
      <rect width="32" height="32" rx="4" fill="#D8232A" />
      <rect x="13" y="6" width="6" height="20" fill="#ffffff" />
      <rect x="6" y="13" width="20" height="6" fill="#ffffff" />
    </svg>
  );
}
